import { Button, Spin } from "antd";
import React, { useEffect, useState } from "react";
import {
   EditProfile,
   EditProfilePic,
   KapOrgIcon2,
   OrganizationOfficeBuilding,
   UserIcon
} from "../../assets/icons";
import EditProfileComponents from "./EditProfileComponents";
import AuthService from "../../base/services/authentication.service";
import { UserRolesEnum } from "../auth/userRoles.enum";
import EditProfilePicture from "./modals/EditProfilePicture";
import { httpService } from "../../base/services/httpService.service";
import Axios from "axios";
import { useAvatarStore } from "../../../_metronic/layout/components/header-mobile/store/useAvatarStore";
import { useTranslation } from "../../i18n/LanguageContext";

const ProfileInfo = () => {
   const { t } = useTranslation();
   const [isEditMode, setIsEditMode] = useState(false);
   const [loading, setLoading] = useState(false);
   const profileImage = useAvatarStore((state) => state.profileImage);
   const setProfileImage = useAvatarStore((state) => state.setProfileImage);

   const handleEditClick = () => {
      setIsEditMode(!isEditMode);
   };

   const handleSaveClick = () => {
      setIsEditMode(false);
   };
   const handleCancelClick = (resetForm) => {
      resetForm();
      setIsEditMode(false);
   };

   const isHumanitarian = AuthService.isAuthorized([UserRolesEnum.Consultant]);

   const [openEditPic, setOpenEditPic] = useState(false);

   const handleOpenEditProfilePic = () => {
      setOpenEditPic(true);
   };

   const handleCloseEditProfilePic = () => {
      setOpenEditPic(false);
   };

   const [user] = useState(AuthService.getUser());
   const [imageLoading, setImageLoading] = useState(false);
   const getProfilePic = async () => {
      setImageLoading(true);
      try {
         await httpService.get(`Accounts/get-profile-picture?userId=${user?.id}`, async (res) => {
            const fileKey = res?.message;

            if (fileKey) {
               const fileUrl = `${process.env.REACT_APP_FILE_MANAGEMENT}FileData/getFileByFileKey?platformId=${process.env.REACT_APP_PLATFORM_KEY}&fileKey=${fileKey}`;
               const response = await Axios.get(fileUrl);

               if (response?.data?.data) {
                  setProfileImage(response?.data?.data);
               } else {
                  console.error("No image URL found in the file management response.");
               }
            } else {
               console.error("No file key found in the response.");
            }
         });
      } catch (error) {
         console.error("Error fetching profile picture:", error);
      } finally {
         setImageLoading(false);
      }
   };

   useEffect(() => {
      if (isHumanitarian) {
         getProfilePic();
      }
   }, [isHumanitarian]);
   return (
      <>
         <div style={{ padding: "40px 32px", backgroundColor: "#F5F9FC", minHeight: "100%" }}>
            <div
               className="d-flex justify-content-between align-items-center flex-wrap"
               style={{
                  backgroundColor: "#fff",
                  padding: "24px 32px",
                  borderRadius: "8px 8px 0 0"
               }}
            >
               <span
                  style={{
                     color: "#003DAA",
                     fontWeight: 600,
                     fontFamily: "poppins",
                     fontSize: "24px"
                  }}
               >
                  {t("profile-information-label")}
               </span>
               {!isEditMode && (
                  <Button
                     icon={<img src={EditProfile} alt="" />}
                     className="edit-outlined"
                     onClick={handleEditClick}
                  >
                     {t("edit-action")}
                  </Button>
               )}
            </div>
            {isHumanitarian ? (
               <div
                  className="d-flex align-items-start flex-wrap flex-md-nowrap"
                  style={{ gap: "60px", backgroundColor: "#fff", padding: "24px 32px 40px 32px" }}
               >
                  <div style={{ position: "relative" }}>
                     {/* <img
                        src={profileImage || UserIcon}
                        alt="Profile"
                        style={{ maxWidth: "180px" }}
                     /> */}

                     {imageLoading ? (
                        <Spin />
                     ) : (
                        <img
                           src={profileImage || UserIcon}
                           alt="Profile Preview"
                           style={{
                              maxWidth: "180px",
                              borderRadius: "50%",
                              height: "180px"
                           }}
                        />
                     )}
                     {isEditMode && (
                        <img
                           onClick={handleOpenEditProfilePic}
                           src={EditProfilePic}
                           alt=""
                           style={{
                              width: "44px",
                              position: "absolute",
                              bottom: 15,
                              right: 0,
                              borderRadius: "50%",
                              border: "none",
                              cursor: "pointer"
                           }}
                        />
                     )}
                  </div>
                  <div
                     style={{
                        backgroundColor: "#fff",
                        width: "100%"
                     }}
                  >
                     <EditProfileComponents
                        isEditMode={isEditMode}
                        loading={loading}
                        setLoading={setLoading}
                        handleSaveClick={handleSaveClick}
                        handleCloseEditForm={handleCancelClick}
                     />
                  </div>
               </div>
            ) : (
               <div
                  style={{
                     border: "1.5px solid #DFE6FF",
                     borderRadius: "0 0 8px 9px",
                     padding: "24px 32px",
                     backgroundColor: "#fff"
                  }}
               >
                  <EditProfileComponents
                     isEditMode={isEditMode}
                     loading={loading}
                     setLoading={setLoading}
                     handleSaveClick={handleSaveClick}
                     handleCloseEditForm={handleCancelClick}
                  />
               </div>
            )}
         </div>
         <EditProfilePicture
            open={openEditPic}
            setOpen={setOpenEditPic}
            onCancel={handleCloseEditProfilePic}
            setProfileImage={setProfileImage}
         />
      </>
   );
};

export default ProfileInfo;
